import { action } from 'typesafe-actions';

import ActionTypes from '../constants/rules';
import { Rule } from 'lib/constraintsChecker/Rule';
import { ActionMessage } from 'lib/constraintsChecker/ActionMessage';

export const getRules = () => action(ActionTypes.RULES_REQUEST);
export const getRulesSuccess = (rules: Rule[], messages: ActionMessage[]) =>
  action(ActionTypes.RULES_SUCCESS, { rules, messages });
export const getRulesFailure = (error: object) =>
  action(ActionTypes.RULES_FAILURE, { error });
